import { getCsrfToken } from '@/integrations/php/client';

export interface DuplicateLeadEntry {
  id: string;
  name: string;
  service: string;
  stage: string;
  partner_id: string | null;
  partner_name: string | null;
  created_at: string | null;
}

export interface DuplicateLeadHistory {
  current: DuplicateLeadEntry;
  data: DuplicateLeadEntry[];
  pagination: { page: number; per_page: number; total: number; total_pages: number };
}

export async function fetchLeadDuplicates(leadId: string, page: number, signal?: AbortSignal): Promise<DuplicateLeadHistory> {
  const params = new URLSearchParams({ lead_id: leadId, page: String(page) });
  const response = await fetch(`/api/admin/lead-duplicates.php?${params}`, {
    credentials: 'include',
    headers: { 'X-CSRF-Token': await getCsrfToken() },
    signal,
    cache: 'no-store',
  });
  const body = await response.json().catch(() => null);
  if (!response.ok || !body?.current || !Array.isArray(body?.data) || !body?.pagination) {
    throw new Error(body?.error?.message || 'Δεν φορτώθηκε το ιστορικό της επαφής.');
  }
  return body;
}
